import DIV from '../../DOM/div/DIV.js';
import HEADER from '../../DOM/header/HEADER.js';
import { textBlock } from '../../DOM/div/TEXTBLOCK/TEXTBLOCK.js';
import { makeAttrStruct } from '../../../enums/ModelAttr.js';
import { makeDataStruct } from '../../../enums/ModelData.js';
import { makeStruct } from '../../../enums/MODELS.js';
// Model Structure
export const heroAttr = makeAttrStruct([
    ['class'],
    ['name']
]);
export const heroData = makeDataStruct([
    ['screen'],
    ['heading1'],
    ['heading2'],
    ['description']
]);
export const heroModel = makeStruct([
    ['attributes', heroAttr],
    ['data', heroData]
]);
// Simplified Model
export function hero(className, name, screen, heading1, heading2, description) {
    return {
        attributes: heroAttr(className, name),
        data: heroData(screen, heading1, heading2, description)
    };
}
/** A full width HEADER with a fixed height */
export default class HERO extends HEADER {
    screen;
    constructor(node, model) {
        super(node, model);
        this.addClass('hero');
        this.screen = new DIV(this, model.data.screen).addClass('screen');
        this.heading1 = this.screen.addHeading(model.data.heading1);
        this.heading2 = this.screen.addHeading(model.data.heading2);
        this.description = this.screen.addTextblock(textBlock()).addSpan(model.data.description);
    }
}
